module.exports = __webpack_public_path__ + "img/hotel_active.0f3e7a25.svg";